import types from '../types'

const initialState = {
  registrationEnabled: null,
  loading: false,
  error: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_REGISTRATION_STATUS_REQUEST:
      return { ...state, error: null, loading: true }

    case types.FETCH_REGISTRATION_STATUS_ERROR:
      return { ...state, error: action.payload, loading: false }

    case types.FETCH_REGISTRATION_STATUS_SUCCESS:
      return {
        ...state,
        registrationEnabled: action.payload.registration_enabled,
        loading: false,
        error: null
      }

    default:
      return state
  }
}
